export const KKTC_BOLGELERI = [
  { 
    id: 1, 
    name: "Lefkoşa", 
    koyler: ["LEFKOŞA MERKEZ", "ALAYKÖY", "BALIKESİR", "DEĞİRMENLİK", "DEMİRHAN", "DİLEKKAYA", "GÖNYELİ", "HAMİTKÖY", "HASPOLAT", "MİNARELİKÖY", "YENİCEKÖY", "YILMAZKÖY"] 
  },
  { 
    id: 2, 
    name: "Mağusa", 
    koyler: ["GAZİMAĞUSA MERKEZ", "AKDOĞAN", "BEYARMUDU", "GEÇİTKALE", "İNÖNÜ", "PAŞAKÖY", "TATLISU", "VADİLİ", "YENİBOĞAZİÇİ"] 
  },
  { 
    id: 3, 
    name: "Girne", 
    koyler: ["GİRNE MERKEZ", "ALSANCAK", "BELLAPAİS", "ÇATALKÖY", "DİKMEN", "ESENTEPE", "KARAOĞLANOĞLU", "LAPTA", "OZANKÖY", "ZEYTİNLİK"] 
  },
  { 
    id: 4, 
    name: "Güzelyurt", 
    koyler: ["GÜZELYURT MERKEZ", "AKÇAY", "AYDINKÖY", "BOSTANCI", "KALKANLI", "ZÜMRÜTKÖY"] 
  },
  { 
    id: 5, 
    name: "İskele", 
    koyler: ["İSKELE MERKEZ", "BAFRA", "BOĞAZ", "MEHMETÇİK"] 
  },
  { 
    id: 6, 
    name: "Karpaz", 
    koyler: ["DİPKARPAZ", "YENİ ERENKÖY", "ZİYAMET", "KUMYALI", "BÜYÜKKONUK", "SİPAHİ"] 
  },
  { 
    id: 7, 
    name: "Lefke", 
    koyler: ["LEFKE MERKEZ", "DENİZLİ", "GAZİVEREN", "GEMİKONAĞI", "YEDİDALGA", "YEŞİLYURT"] 
  }
];